import { useEffect, useState } from 'react'
import { backendAccessGet, backendAccessPost } from '../Utils/Authentication'

import Table from 'react-bootstrap/Table'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import ButtonGroup from 'react-bootstrap/ButtonGroup'
import Form from 'react-bootstrap/Form'
import Container from 'react-bootstrap/Container'

import { Helmet } from 'react-helmet'



export function AddDepartmentModal( props )
{
    const showModal = props.showModal 
    const setShowModal = props.setShowModal 

    const addDepartment = props.addDepartment

    const [ name, setName ] = useState("")
    const [ quota, setQuota ] = useState("")

    const [ nameError, setNameError ] = useState(false)
    const [ quotaError, setQuotaError ] = useState(false)

    useEffect( () => {
        if( showModal )
        {
            setName("")
            setQuota("")
            setNameError(false)
            setQuotaError(false)
        }
    }, [ showModal] )

    const add = () => {
        setNameError(false)
        setQuotaError(false)
        let has_error = false
        if( name == "" )
        {
            setNameError(true)
            has_error = true 
        }

        if( quota == "" )
        {
            setQuotaError(true)
            has_error = true 
        }

        let quotaInt = parseInt(quota);
        if( isNaN(quotaInt) )
        {
            setQuotaError(true)
            has_error = true;
        }

        if( has_error )
        {
            return
        }

        addDepartment(name, quotaInt)
    }

    return (
        <Modal show={showModal} onHide={ e => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Add Department</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding:'10px'}}>
                <div>
                    <b>Department Name</b>
                </div>
                <div style={{ marginBottom:'10px' }}>
                    <Form.Control value={name} onChange={e => setName(e.target.value)} isInvalid={nameError} />
                </div>
                <div>
                    <b>Rotations Quota</b>
                </div>
                <div>
                    <Form.Control value={quota} onChange={e => setQuota(e.target.value)} isInvalid={quotaError} />
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={e => setShowModal(false)}>
                    Close
                </Button>
                <Button variant="primary" onClick={add}>
                    Add
                </Button>

            </Modal.Footer>

        </Modal>
    )
}

export function EditDepartmentModal( props )
{
    const department = props.department 

    const showModal = props.showModal 
    const setShowModal = props.setShowModal 

    const updateDep = props.update

    const [ name, setName ] = useState("")
    const [ quota, setQuota ] = useState("")

    const [ nameError, setNameError ] = useState(false)
    const [ quotaError, setQuotaError ] = useState(false)

    useEffect( () => {
        if( showModal )
        {
            setName(department.name)
            setQuota(department.quota)
            setNameError(false)
            setQuotaError(false)
        }
    }, [ showModal] )

    const update = () => {
        setNameError(false)
        setQuotaError(false)
        let has_error = false
        if( name == "" )
        {
            setNameError(true)
            has_error = true 
        }

        if( quota == "" )
        {
            setQuotaError(true)
            has_error = true 
        }

        let quotaInt = parseInt(quota);
        if( isNaN(quotaInt) )
        {
            setQuotaError(true)
            has_error = true;
        }

        if( has_error )
        {
            return
        }

        updateDep( department.uid, name, quotaInt, setShowModal)
    }

    return (
        <Modal show={showModal} onHide={ e => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Department</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding:'10px'}}>
                <div>
                    <b>Department Name</b>
                </div>
                <div style={{ marginBottom:'10px' }}>
                    <Form.Control value={name} onChange={e => setName(e.target.value)} isInvalid={nameError} />
                </div>
                <div>
                    <b>Rotations Quota</b>
                </div>
                <div>
                    <Form.Control value={quota} onChange={e => setQuota(e.target.value)} isInvalid={quotaError} />
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={e => setShowModal(false)}>
                    Close
                </Button>
                <Button variant="primary" onClick={update}>
                    Update
                </Button>

            </Modal.Footer>

        </Modal>
    )
}

export function DepartmentRow( props )
{
    const index = props.index
    const department = props.department

    const remove = props.remove
    const update = props.update

    const [ showEditModal, setShowEditModal ] = useState(false)

    return (
        <>
            <tr>
                <td> { index + 1} </td>
                <td> { department.name } </td>
                <td> { department.uid } </td>
                <td> 
                    <ButtonGroup size="sm">
                        <Button variant="outline-secondary" onClick={ e => setShowEditModal(true)}>Edit</Button>
                        <Button variant="outline-danger" onClick={ e => remove(department.uid) }>Remove</Button>
                    </ButtonGroup>
                </td>
            </tr>
            <EditDepartmentModal department={department}
                                 showModal={showEditModal}
                                 setShowModal={setShowEditModal}
                                 update={update}
            />
        </>
    )
}

export default function DepartmentBuilder( props )
{
    const [ departments, setDepartments ] = useState([])
    const [ showAddModal, setShowAddModal ] = useState(false)

    useEffect( () => { 
        backendAccessGet('/api/departments/fetch/').then( res => {
            if('error_message' in res)
            {
                alert( res['error_message'] )
                return
            }

            setDepartments( res.departments )
        }) 

    }, [])

    const addDepartment = ( name, quota ) => { 
        var data = {}
        data['name'] = name
        data['quota'] = quota

        console.log( data )

        backendAccessPost('/api/departments/add/', data).then( res => {
            if('error_message' in res)
            {
                alert( res['error_message'] )
                return
            }

            setDepartments( res.departments )
            setShowAddModal(false)
        })
    }

    const removeDepartment = ( uid ) => {
        var check = window.confirm("Delete department?")

        if( check )
        {
            var data = {}
            data['uid'] = uid
            backendAccessPost('/api/departments/remove/', data ).then( res => {
                if('error_message' in res)
                {
                    alert( res['error_message'] )
                    return
                }
                setDepartments( res['departments'] )
            })
        }
    }

    const updateDepartment = ( uid, name, quota, setShowEditModal ) => {
        var data = {}
        data['uid'] = uid 
        data['name'] = name 
        data['quota'] = quota 

        backendAccessPost('/api/departments/update/', data).then( res => {
            if('error_message' in res)
            {
                alert( res['error_message'] )
                return
            }

            setDepartments( res.departments )
            setShowEditModal(false)
        })
    }

    return (
        <>
            <Helmet>
                <title> Clinic Manager | Departments </title>
            </Helmet>

            <Container style={{ height:'calc(100vh - 60px)', maxWidth:'1000px', overflowY:'scroll'}}>

            <div className="d-flex justify-content-center align-items-center" 
                 style={{ width:'100%', padding:'10px'}}>
                <ButtonGroup size="sm">
                    <Button  onClick={ e => setShowAddModal(true)}   
                    >
                        Add Department
                    </Button>
                </ButtonGroup>
            </div>

            <div style={{ width:'100%' }}>
                <Table striped hover>
                    <thead>
                        <tr>
                            <th style={{ width: "20px"}}>#</th>
                            <th style={{ width: "80px"}}>Name</th>
                            <th style={{ width: "80px"}}>UID</th>
                            <th style={{ width: "40px"}}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        { departments.map( (d,idx) =>
                        <DepartmentRow department={d} index={idx}
                                       remove={removeDepartment}
                                       update={updateDepartment}
                        />
                        )}
                    </tbody>
                </Table>
            </div>
            <AddDepartmentModal showModal={showAddModal}
                                setShowModal={setShowAddModal}
                                addDepartment={addDepartment}
            />
            </Container>
        </>
    )
}


